const LoginTypes = {
	LOGIN_START: 'login_start',
	LOGIN_SUCCESS: 'login_success',
	LOGIN_FAILURE: 'login_failure',
	LOGIN_RESPONSE_CHANGED: 'login_response_changed',
	LOGIN_RESPONSE_REST_START: 'login_response_rest_start',
	PERSIST_LOGIN_DATA_START: 'persist_login_data_start',
	LOGIN_KEY: 'UserLoginWebToken',
} as const;

export default LoginTypes;
